import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/**
 * Director/professor → student personal notification. The backend scopes
 * professors to students in shifts they teach.
 */
export function useSendNotification() {
    return useMutation({
        mutationFn: (dto) => apiClient('/notifications/send', {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
    });
}
//# sourceMappingURL=useSendNotification.js.map